var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aprh__authentication__reset-password"},[_c('div',{staticClass:"aprh__authentication__form__description"},[_vm._v(_vm._s(_vm.$t('authentication.passwordRequirements')))]),_c('base-password',{staticClass:"aprh__authentication__form__field",attrs:{"input":_vm.input,"settings":{
            label: { class: 'capitalize', text: _vm.$t('global.password') },
            input: {
                name: 'password',
                class: 'aprh__authentication__form__field__input',
                placeholder: _vm.$t('global.password'),
                browserAutocomplete: 'new-password',
                fileValidation: 'password',
                errors: [{
                    type: 'validateStrenghtPassword', warning: _vm.$t('error.password')
                }],
                isMissing: _vm.errors.missing.password,
                noListener: true
            }
        }}}),_c('base-password',{staticClass:"aprh__authentication__form__field",attrs:{"input":_vm.input,"settings":{
            label: { class: 'capitalize', text: _vm.$t('global.confirmPassword') },
            input: {
                name: 'confirmPassword',
                class: 'aprh__authentication__form__field__input',
                placeholder: _vm.$t('global.confirmPassword'),
                browserAutocomplete: 'confirm-password',
                fileValidation: 'confirmPassword',
                errors: [{
                    type: 'sameAsPassword', warning: _vm.$t('error.confirmPassword')
                }],
                validationParameter: _vm.payload.password,
                isMissing: _vm.errors.missing.confirmPassword,
                noListener: true
            }
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }